module.exports = __webpack_public_path__ + "index_pc/img/dingyi_6-7.c8198246.png";